import S3 from 'aws-sdk/clients/s3';
import AWS from 'aws-sdk';

import config from 'config';

export const putObject = (params, callback) => {
  return (dispatch, getState) => {
    const { file, path, signals, prefix } = params,
      { AccessKeyId, SecretKey, SessionToken } = getState().user.credentials;

    dispatch({ type: signals.onStart });

    const s3 = new S3({
        apiVersion: '2006-03-01',
        params: { Bucket: config.s3.BUCKET },
        signatureVersion: 'v4',
        region: config.s3.REGION,
        credentials: new AWS.Credentials(AccessKeyId, SecretKey, SessionToken),
      }),
      key = `${path}${prefix}${Date.now()}.${file.type.split('/')[1]}`;

    s3.putObject(
      {
        Bucket: config.s3.BUCKET,
        Key: key,
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
      },
      (err, data) => {
        if (err)
          return dispatch({
            type: signals.onFailure,
            payload: String(err),
          });

        dispatch({ type: signals.onSuccess });

        const fileUrl = `${config.s3.URL}${config.s3.BUCKET}/${key}`;

        callback && callback(fileUrl);
      },
    );
  };
};
